import { render, staticRenderFns } from "./omt-h1.vue?vue&type=template&id=798ca405&scoped=true&"
var script = {}
import style0 from "./omt-h1.vue?vue&type=style&index=0&id=798ca405&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ca405",
  null
  
)

export default component.exports